import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@material-ui/core";

export default function HoldBillDialog({ open, onClose, onCreate }) {
  const [label, setLabel] = useState("");

  const handleCreate = async () => {
    const trimmed = (label || "").trim();
    if (!trimmed) return;
    try {
      await onCreate(trimmed);
      setLabel("");
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  const handleClose = () => {
    setLabel("");
    onClose();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && (label || "").trim()) {
      handleCreate();
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      maxWidth="xs" 
      fullWidth
      style={{ zIndex: 10000 }}
      PaperProps={{ style: { zIndex: 10000 } }}
    >
      <DialogTitle>Hold Bill</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Name / Table / Customer"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          onKeyDown={handleKeyDown}
          variant="outlined"
          placeholder="e.g. Table-5, Rahul, Order-1"
          style={{ marginTop: 8 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleCreate}
          color="primary"
          variant="contained"
          disabled={!(label || "").trim()}
        >
          Hold
        </Button>
      </DialogActions>
    </Dialog>
  );
}
